import moment from 'moment';
import _ from 'lodash';
import template from './fazeForDay.html';
import $ from 'jquery';

class FazeForDayController {
    constructor(AppConfiguration, DS, $q) {
        this.fazeView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'DashboardView');
        this.datastore = () => {
            return DS;
        };
        this.$q = () => $q;
    }

    $onInit() {
        this.mode = 'danas';
    }

    $onChanges(changes) {
        this.days = changes.days.currentValue;
        this.getState();
    }

    onDayClicked(day) {
        this.onClick({ day: day });
    }

    no_reservation(header_day, item) {
        // console.log(header_day.format('YYYY-MM-DD'), item);

        // if (item && item.datum_probe === header_day.format('YYYY-MM-DD')) {
        //     return false;
        // }
        return true;
    }

    // getState() {
    //     this.items = [];
    //     this.pivot = [];
    //     _.forEach(this.days, day => {
    //         let item = {};
    //         this.getFaze(day).then(response => {
    //             item.date = day;
    //             item.datum = moment(day).format();
    //             item.probe = response;
    //             response.forEach((r, i) => {
    //                 if (this.pivot.length <= i) {
    //                     this.pivot.push([]);
    //                 }
    //                 this.pivot[i].push(r);
    //             });
    //         });

    //         this.items.push(item);
    //     });
    // }

    getItemForRow(row, dan) {
        const probe_za_dan = this.dani.filter(f => f.datum === dan);
        if (probe_za_dan.length === 1) {
            const probe = probe_za_dan[0].response;
            if (probe.length > row) {
                return probe[row];
            }
        }
        return null;
    }

    getState() {
        const $q = this.$q();
        this.items = [];
        this.dani = [];
        this.max_proba = 0;

        $q.all(this.days.map(day => this.getFaze(day))).then(responses => {
            _.forEach(responses, (response, i) => {
                const dan = {
                    datum: this.days[i],
                    broj_proba: response.length,
                    response: response
                };
                _.forEach(response, r => {
                    this.items.push(r);
                });

                this.dani.push(dan);
            });

            const max_proba = _.maxBy(this.dani, 'broj_proba');
            this.max_proba = [...Array.from(Array(max_proba.broj_proba).keys())];
        });
    }

    getFaze(day) {
        const DS = this.datastore();
        return DS.findAll(
            'FazaNaloga',
            { aktivne: 1, datum_probe: moment(day).format('YYYY-MM-DD'), ordering: 'termin_probe' },
            { bypassCache: true }
        ).then(response => {
            return response;
        });
    }
}

FazeForDayController.$inject = ['AppConfiguration', 'DS', '$q'];

const FazeForDayComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: FazeForDayController,
    controllerAs: 'vm',
    bindings: {
        days: '<',
        onClick: '&'
    }
};

export { FazeForDayComponent };
export { FazeForDayController };



// WEBPACK FOOTER //
// ./app/components/fazaNaloga/fazeForDay.component.js